import { render, staticRenderFns } from "./LeaveSectionExportLegend.vue?vue&type=template&id=239bc60e&scoped=true&"
import script from "./LeaveSectionExportLegend.vue?vue&type=script&lang=js&"
export * from "./LeaveSectionExportLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239bc60e",
  null
  
)

export default component.exports